<template src="./MapControl.html"> </template>


<script>
import MapControlTitle from '@/components/MapControl/MapControlTitle/MapControlTitle.vue';
import MapControlButton from '@/components/MapControl/MapControlButton/MapControlButton';
import MapActionsButton from '@/components/MapControl/MapActionsButton/MapActionsButton';
import BottomPanel from '@/modules/BottomPanel/BottomPanel.vue';

import Social from '@/modules/Social/Social.vue';

import { mapActions, mapState } from 'vuex';

export default {
    name: 'ModuleMapControl',
    components: {
        MapControlTitle,
        MapControlButton,
        MapActionsButton,
        BottomPanel,
        Social,
    },
    data: () => ({
        fav: true,
      menu: false,
      message: false,
      hints: false,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],

      mapTypeRadioGroup: 'current'
    }),
    computed: {
        ...mapState({
            dropPinStatus: state => state.dropPinStatus,

            dataAnalysisStatus: state => state.dataAnalysisStatus,

            mapConfigOne: state => state.mapConfigOne,

            viewNotificationsManager: state => state.notifications.viewNotificationsManager,
        }),

        showDropPinIndicator: function() {
            return this.dropPinStatus && !this.dataAnalysisStatus;
        },
    },
    methods: {

        ...mapActions({
            setDropPinStatus: 'setDropPinStatus',

            setViewNotificationsManager: 'setViewNotificationsManager',

            setWfsLayer: 'setWfsLayer',

            setMapType: 'setMapType',

            setMapOne: 'setMapConfigOne',

            setWsLayerStatus: 'setWsLayerStatus',

            setDataAnalysisStatus: 'setDataAnalysisStatus',

            setDataAnalysisFullScreen: 'setDataAnalysisFullScreen',
        }),

        mapTypeOnChange: function(e) {
            this.setMapType(e);

            let toLayer = this.mapConfigOne.layer.replace("Dev", "");
            toLayer = toLayer.replace("His", "");

            toLayer += e;
            
            let map1 = {
                url: this.mapConfigOne.url,
                layer: toLayer,
                visibility: this.mapConfigOne.visibility
            };

            this.setMapOne(map1);
        },

        onStatesChange: function(e) {
            this.setWfsLayer({boundaries: 'state', status: e});
        },

        onCountiesChange: function(e) {
            this.setWfsLayer({boundaries: 'county', status: e});
        },

        setDropPin: function() {
            if (this.dropPinStatus)
                this.setDataAnalysisStatus(false);
            this.setDropPinStatus(!this.dropPinStatus);
        },

        setNotificationsStatus() {
            const enabling = !this.viewNotificationsManager;
            this.setWsLayerStatus(false);
            this.setViewNotificationsManager(enabling);
            if (enabling) {
                this.setDataAnalysisFullScreen(false);
            }
        },
    },
}
</script>

<style lang="scss" src="./MapControl.scss"> </style>